import { Graphics } from 'pixi.js';
import { ComponentStore } from '@ecs/world';

export function destroyAllGraphics(store: ComponentStore<Graphics>) {
	store.forEach((graphic) => {
		graphic.parent?.removeChild(graphic);
		graphic.destroy();
	});
	store.clear();
}


